module.exports = {"220272001":"高新街道","220272002":"新北街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220272.json
// module id = 712
// module chunks = 0